export default __webpack_public_path__ + "locales/az/InfoPanel.json?hash=247ee6d04030e9f6ea14161025d553da";